<template>
	<section class="blockquote container margin-auto margin-bottom-lg">
		<div class="html-content">
			<blockquote :author="data.author">
				<p v-html="data.quoted_text"></p>
				<em v-html="data.author" v-if="data.author"></em>
			</blockquote>
		</div>
	</section>
</template>

<script>
export default {
	name: 'blockqoute',
	props: ['data'],
	computed: {},
	components: {},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-blockqoute {
	margin-top: 75px;
	@include mquery($tablet) {
		margin-top: 55px;
	}
	@include mquery($phone) {
		margin-top: 35px;
	}
}
</style>
